<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div class="page_main_sec">
        <div class="row cart-section" style="display:none">
            <div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                    <mat-label for="select_work_item_type">Select Work Item Type</mat-label>
                    <mat-select [(value)]="SetDocTypeDropDownValue" id="select_work_item_type">
                        <mat-option [value]="doc.docTypeId" *ngFor="let doc of docTypeList">
                            {{doc.docTypeName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row cart-section upload-file-cart-section">
            <div class="fileUploadTitle col-lg-12">
                <span>Upload Excel File</span>
            </div>
            <div class="col-lg-8">
                <div [style.width.%]="100">
                    <mat-toolbar class="matBG">
                        <input type="text" [hidden]="true">
                        <mat-label [attr.title]="fileTitle" class="file-names">{{selectedExcelFile}}</mat-label>
                        <button class="Mat_btn_Custom_Width choose-file-btn" type="button" mat-flat-button
                            color="primary" (click)="invFileUpload.click()">
                            Choose file
                        </button>
                    </mat-toolbar>
                    <input [attr.type]="fileControlType" #invFileUpload (change)="onSelectExcelFile($event)" hidden />
                </div>
            </div>
            <div class="col-lg-2">
                <div class="textCenter upload-btn">
                    <button class="waves-effect waves-light btn smallButton" (click)="uploadBulkInvoice()"
                        [disabled]="selectedExcelFile==browseMessage">
                        Submit
                    </button>
                </div>
            </div>
        </div>
        <div class="row cart-section">
            <div class="dashboard-tabs" id="invoice-History-table">
                <div *ngIf="lstHistoryData.length>0" class="grid">
                    <!--   <app-basic-gridview [lstData]="lstHistoryData" [gridTitle]="' '" [showRefreshButton]='true'
                                (RefreshEvent)="onRefreshClick()"></app-basic-gridview> -->
                    <app-basic-gridview [lstData]="lstHistoryData" [gridTitle]="'UPLOAD HISTORY'"
                        [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                        [showPagination]="true" [hyperlinkCols]="hyperLinkColumns"
                        (cellClickEvent)="advanceSearchCellClick($event)"
                        [columnsToHide]="uploadColumnsToHide"></app-basic-gridview>

                </div>
            </div>
        </div>
    </div>
</div>